import React, { useEffect } from 'react';

interface ThemeColorProps {
  color: 'white' | 'gray';
  children?: React.ReactNode;
}

const ThemeColor: React.FC<ThemeColorProps> = ({ color, children }) => {
  useEffect(() => {
    const themeColorTag: HTMLMetaElement | null = document.head.querySelector(
      'meta[name="theme-color"]'
    );
    if (themeColorTag) {
      if (color === 'white') {
        themeColorTag.content = '#ffffff';
      }
      if (color === 'gray') {
        themeColorTag.content = '#f8fafc';
      }
    }
  }, [color]);

  return <>{children}</>;
};

export default ThemeColor;
